
import { ActivityType, ActivityComment, AppState } from '@/types';
import { GeolocationData } from '@/hooks/useGeolocation';
import { logActivityHelper, formatLocationForLog } from '../actionHelpers';
import { supabase } from '@/integrations/supabase/client';

export const createActivityActions = (state: AppState, dispatch: any) => {
  const logActivity = (activityType: ActivityType) => {
    if (!state.isAuthenticated || !state.user) {
      return;
    }
    
    logActivityHelper(activityType, false);
    dispatch({ type: 'LOG_ACTIVITY', payload: { activityType } });
  };

  const logEnhancedActivity = (activityType: ActivityType, duration?: number, notes?: string, photoUrl?: string, locationData?: GeolocationData) => {
    logActivityHelper(activityType, true);
    
    console.log('📝 Enhanced activity details:', {
      location: formatLocationForLog(locationData)
    });
    
    dispatch({ type: 'LOG_ENHANCED_ACTIVITY', payload: { activityType, duration, notes, photoUrl, locationData } });
  };

  const likeActivity = (activityId: string) => {
    if (!state.user) {
      return;
    }
    dispatch({ 
      type: 'LIKE_ACTIVITY', 
      payload: { activityId, userId: state.user.id } 
    });
  };

  const commentOnActivity = (activityId: string, content: string) => {
    if (!state.user) {
      return;
    }
    const comment: ActivityComment = {
      id: crypto.randomUUID(),
      userId: state.user.id,
      userName: state.user.name,
      text: content,
      content,
      timestamp: new Date()
    };
    dispatch({ 
      type: 'COMMENT_ACTIVITY', 
      payload: { activityId, comment } 
    });
  };

  const undoLastActivity = async () => {
    if (!state.user?.id) {
      throw new Error('User not authenticated');
    }

    // Get the most recent activity from Supabase
    const { data: lastActivity, error: fetchError } = await supabase
      .from('activities')
      .select('*')
      .eq('user_id', state.user.id)
      .order('timestamp', { ascending: false })
      .limit(1)
      .single();

    if (fetchError || !lastActivity) {
      throw new Error('No activity found to undo');
    }

    // Delete the activity from Supabase
    const { error: deleteError } = await supabase
      .from('activities')
      .delete()
      .eq('id', lastActivity.id);

    if (deleteError) {
      throw new Error('Failed to delete activity');
    }

    // Calculate credits to deduct (points * 0.1)
    const creditsToDeduct = lastActivity.points * 0.1;

    // Dispatch the undo action to update local state
    dispatch({
      type: 'UNDO_LAST_ACTIVITY',
      payload: {
        activityId: lastActivity.id,
        points: lastActivity.points,
        activityCredits: creditsToDeduct
      }
    });
  };

  return {
    logActivity,
    undoLastActivity,
    logEnhancedActivity,
    likeActivity,
    commentOnActivity,
  };
};
